import { useMutation } from "@apollo/client";
import { DeepPartial, useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { CREATE_PRICE_RULE } from "../price-rule.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreatePriceRuleInput } from "../../../__generated__/globalTypes";
import {
  CreatePriceRuleMutation,
  CreatePriceRuleMutationVariables,
} from "../../../__generated__/CreatePriceRuleMutation";

interface IProps {
  defaultValues: DeepPartial<CreatePriceRuleInput>;
  onCompleted: (id?: number | null) => any;
}

export const useCreatePriceRule = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreatePriceRuleInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreatePriceRuleMutation,
    CreatePriceRuleMutationVariables
  >(CREATE_PRICE_RULE, {
    refetchQueries: ["PriceRulesQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createPriceRule?.ok) {
        onCompleted(data.createPriceRule.id);
      } else {
        throw Error(data?.createPriceRule?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
